<template>
    <div class="app-btn-container">
        <v-btn
            class="square app-btn"
            :color="application.color"
            @click="callback(application)"
        >
            <div class="instance-runnings">
                <ns-loader
                    :toLoad="toLoad"
                    @dataFetched="onDataFetched"
                    ref="nsLoader"
                >
                    <div
                        slot="loader"
                        style="background-color: rgba(0,0,0,.3); width: 100%;"
                    >
                        <div style="text-align: center;">
                            <v-progress-circular
                                color="white"
                                indeterminate
                                :width="1"
                                :size="10"
                            ></v-progress-circular>
                        </div>
                    </div>
                    <div slot="content" class="instance-item-count-container">
                        <v-chip outlined>{{ runningInstances }}/{{ instances.length }} </v-chip>
                    </div>
                </ns-loader>
            </div>
            <v-avatar
                v-if="application.image"
                :tile="true"
                :size="100"
                class="app-btn-content"
            >
                <img :src="application.image">
            </v-avatar>
            <div v-else class="app-label app-btn-content">{{ shortName }}</div>
        </v-btn>
        <div 
            v-if="showDeleteBtn"
            class="delete-btn"
            @click="showModalArchive"
        >
            <v-icon small right class="app-delete-icon">delete</v-icon>
        </div>
        <div class="app-text">
            <div class="app-label sub-text"> {{ application.label }}</div>
            <slot name="date">
                <div class="app-date"> {{ application.creation_date | moment('YYYY-MM-DD') }}</div>
            </slot>
        </div>
        <dialog-confirm-delete
            ref="modal-confirm-archive"
            :title="$t('partials.app_btn.archive_app.title')"
            :text-confirm="$t('partials.app_btn.archive_app.text_confirm')"
            :text-decline="$t('partials.app_btn.archive_app.text_decline')"
            :verbose-target="$t('partials.app_btn.archive_app.verbose_target')"
            target-model="application"
            :callback-confirm="archiveApp"
        ></dialog-confirm-delete>
    </div>
</template>

<script>
import DialogConfirmDelete from '@/components/Partials/dialog-confirm-delete.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
export default {

    components: {
        NsLoader,
        DialogConfirmDelete
    },

    props: {
        application: {
            type: Object,
            required: true,
        },

        callback: {
            type: Function,
            required: false,
            default (){
                return ()=>{};
            },
        },
        showDeleteBtn: {
            type: Boolean,
            default: true,
        }
    },

    data (){
        return {
            instances: [],
        };
    },

    computed: {
        toLoad(){
            return [
                {
                    model: 'instances',
                    name: 'instances',
                    filters: {
                        application_uid: this.application.uid?this.application.uid:this.$route.params.applicationUid,
                    },
                },
            ];
        },
        shortName (){
            try{
                return this.application.label.slice(0,2);
            }catch(e){
                return '';
            }
        },
        runningInstances (){
            return this.instances.filter((inst) => inst.deployment_status === 'RUNNING').length;
        },
        hasRunningInstances() {
            let instancesStatus = this.instances.map((inst) => inst.deployment_status)
            return instancesStatus.some(status => status !== 'STOPPED');
        },
    },

    mounted (){
    },

    methods: {
        onDataFetched (res){
            this.$set(this,'instances', res.instances);
        },
        showModalArchive(){
            if(this.hasRunningInstances) {
                this.$notify.error({
                    message: this.$t('partials.app_btn.archive_app.error')
                });
            } else {
                this.$refs['modal-confirm-archive'].open();
            }
        },
        archiveApp() {
            if(this.hasRunningInstances) {
                this.$notify.error({
                    message: this.$t('partials.app_btn.archive_app.error')
                });
            } else {
                this.$store.dispatch('patchItem', {
                    item: {
                        archived: true,
                        url: this.application.url,
                        uid: this.application.uid,
                    },
                    model: 'applications'
                }).then(res => {
                    this.$emit('refreshContent');
                    this.$notify.success({
                        message: this.$t(
                            'partials.app_btn.archive_app.delete_success',
                            {appLabel : this.application.label}
                        )
                    });
                }).catch(err => {
                    console.error(err);
                    this.$notify.error({
                        message: this.$t('partials.app_btn.archive_app.delete_error')
                    });
                }).finally(() => {
                    this.$router.push('/');
                });
            }

        },
    },
};
</script>

<style lang="scss">
.app-btn-container {
    .instance-runnings{
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        width: 100px;
        height: 25px;
        .ns-vue-loader {
            width: 100%;
        }
        .instance-item-count-container{
            display: flex;
            flex-wrap: wrap;
        }
        .theme--dark.v-chip{
            background-color: #bbb !important;
        }
        .v-chip{
            font-size: 9px;
            color: #000;
            display: flex;
            justify-content: center;
            margin-left: auto;
            margin-right: 4px;
            height: 20px !important;
            width: 30px !important;
            padding: 0 !important;
            text-align: center;
            .v-chip__content {
                padding: 0;

                font-size: 12px;
            }
        }
    }
    &:hover .app-text .sub-text{
        overflow: visible;
        white-space: normal;
        max-height: 100em;
    }
    height: 170px;
    .app-btn{
        .v-btn__content{
            width: 100px;
            height: 100px;
        }
        .app-btn-content{
            position: absolute;
            left: 0;
            z-index: 1;
        }
        .app-label{
            font-weight: bold;
            font-size: 33px;
            text-transform: capitalize;
            z-index: 1;
            left: 50%;
            transform: translateX(-50%);
        }

    }
    .app-text{
        text-align: center;
        width: 100px;
        margin-left: 8px;

        .app-date{
            color: #a7a7a7;
            font-size: 12px;
        }
        .sub-text{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            transition: all 0.5s;
            max-height: 1.2em;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/app-btn.vue